module.exports = __webpack_public_path__ + "statics/img/3-1.70960f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/product/icon/3-1.png
// module id = OPAu
// module chunks = 1